import api from '@Services/api';
import { walletLog } from '@Services/students/students.res.types';
import { AxiosResponse } from 'axios';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';

interface WalletLogsCRUD extends CRUDBase<walletLog, walletLog> {}
export class WalletLogsRequester implements WalletLogsCRUD {
	private static instance: WalletLogsRequester;
	static getInstance() {
		if (!WalletLogsRequester.instance) {
			WalletLogsRequester.instance = new WalletLogsRequester();
		}
		return WalletLogsRequester.instance;
	}
	baseURL = 'user/profile';
	getAll(
		payload?: GetAllMeta
	): Promise<AxiosResponse<ApiResponse<walletLog[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<walletLog[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<walletLog[]>>> {
		return await api.post(`${this.baseURL}/${payload.id}/wallet-logs`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<walletLog>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<walletLog>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<walletLog>>>;
	async get(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<walletLog>>> {
		return await api.post(`${this.baseURL}`, { uuid: id });
	}

	async create(
		payload: walletLog
	): Promise<AxiosResponse<ApiResponse<walletLog>>> {
		return await api.post(`${this.baseURL}/create`, payload);
	}
	async update(
		payload: walletLog
	): Promise<AxiosResponse<ApiResponse<walletLog>>> {
		return await api.put(`${this.baseURL}/update`, payload);
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<walletLog>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}/delete`, {
			data: {
				uuid: id,
			},
		});
	}
}
